import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class StandardHardwares extends Component {
  render() {
    return (
      <EntityList apiRoute='api/standardhardwares' title='Remorque - Quincailleries de série' editTitle='Quincaillerie de série' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default StandardHardwares;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/standardHardwares.js
 **/